export default {
  state: {
    isHeaderMenuVisible: true, // 控制头部菜单的显示隐藏 有的页面不需要头部菜单 需要一个单独的变量来控制
    headerMenuExpanded: true, // 控制头部菜单的展开收起动画
    isFixedBarVisible: true, // 控制侧边工具栏
    Mode: 'light',
    pageName: ''
  },
  mutations: {
    // 修改头部状态
    changeHeadStatus(state, data) {
      state.headerMenuExpanded = data
    },

    // 修改头部显示隐藏状态
    SET_HEADER_MENU_VISIBLE(state, isVisible) {
      state.isHeaderMenuVisible = isVisible
    },

    // 修改头部展开收起状态
    SET_HEADER_MENU_EXPANDED(state, isExpanded) {
      state.headerMenuExpanded = isExpanded
    },

    // 修改侧边工具栏显示隐藏状态
    SET_FIXED_BAR_VISIBLE(state, isVisible) {
      state.isFixedBarVisible = isVisible
    },

    // 修改模式
    updateMode(state, data) {
      state.Mode = data
    },

    // 更新 name
    updateName(state, data) {
      state.pageName = data
    }
  },

  actions: {
    updateName({ commit }, data) {
      commit('updateName', data)
    },

    toggleHeaderMenuVisibility({ commit }, shouldVisible) {
      commit('SET_HEADER_MENU_VISIBLE', shouldVisible)
    },

    toggleHeaderMenuExpansion({ commit, state }, shouldExpand) {
      if (state.isHeaderMenuVisible) {
        // 确保只在菜单可见时切换展开/收起状态
        commit('SET_HEADER_MENU_EXPANDED', shouldExpand)
      }
    },

    toggleFixedBarVisibility({ commit }, shouldVisible) {
      commit('SET_FIXED_BAR_VISIBLE', shouldVisible)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js